import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { BranchService } from 'src/app/services/branch.service';

@Component({
  selector: 'app-contact-social',
  templateUrl: './contact-social.component.html',
  styleUrls: ['./contact-social.component.scss'],
})
export class ContactSocialComponent implements OnInit {
  @Input() socials: any = undefined;
  @Input() gallery: any = undefined;
  @Input() customMsg = '';
  public telegram = './assets/icons/telegramwhite.svg';

  constructor(
    private popoverController: PopoverController,
    private branchSv: BranchService
  ) {}

  ngOnInit() {}

  async setSocial(social, value) {
    const url = await this.branchSv.setSocial(
      social,
      value,
      this.customMsg,
      this.gallery
    );
    this.popoverController.dismiss(url);
  }
}
